import { render } from "./CreateReport.vue?vue&type=template&id=407b734b&ts=true"
import script from "./CreateReport.vue?vue&type=script&lang=ts"
export * from "./CreateReport.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__